import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [authType, setAuthType] = useState('user');

    const handleAuth = (type) => {
        setAuthType(type);
        // Navigate directly for now, or use modal logic if preferred. 
        // Based on previous Home.js, it used a modal. 
        // For professional standard, direct navigation or a clean modal is fine.
        // Let's implement the modal trigger behavior or direct navigation.
        // Given the requirement for "clean", direct navigation to login/register is often better than a complex modal 
        // unless the modal is very polished. 
        // Let's keep the modal if we want, but cleaner. 
        // Actually, the previous implementation used a modal for quick access. 
        // I will implement the modal logic in the parent Home.js or here.
        // For modularity, let's emit an event or handle it locally if it's just for this section.
        // However, the modal was global in Home.js. Let's redirect to login for simplicity and professionalism, 
        // or re-implement the modal in Home.js and pass props. 
        // Let's pass a prop 'onOpenModal' to this component? 
        // Or simply navigate to standard routes which is more standard for "professional" apps.
        // Let's go with navigation for a reliable flow.

        if (type === 'user') navigate('/user/login');
        if (type === 'doctor') navigate('/doctor/login');
    };

    return (
        <section id="home" className="hero-section d-flex align-items-center position-relative overflow-hidden">
            <div className="container position-relative z-2">
                <div className="row align-items-center">
                    <div className="col-lg-6 hero-content animate-fade-in-up">
                        <span className="badge bg-soft-primary text-primary px-3 py-2 rounded-pill mb-4 border border-primary-10">
                            <i className="bi bi-shield-check me-2"></i> Trusted by 10,000+ Patients
                        </span>
                        <h1 className="display-4 fw-bold text-dark mb-4 lh-tight">
                            Expert Health Care <br />
                            <span className="text-primary position-relative">
                                at Your Fingertips.
                                <svg className="position-absolute bottom-0 start-0 w-100" style={{ height: '12px', opacity: 0.2, fill: 'var(--primary-color)', zIndex: -1 }} viewBox="0 0 100 10" preserveAspectRatio="none">
                                    <path d="M0 5 Q 50 10 100 5 L 100 10 L 0 10 Z" />
                                </svg>
                            </span>
                        </h1>
                        <p className="lead text-secondary mb-5 pe-lg-5">
                            Connect with top-tier specialists, manage prescriptions, and get expert medical advice instantly. Safe, secure, and purely professional.
                        </p>
                        <div className="d-flex gap-3 flex-wrap">
                            <button
                                className="btn btn-primary btn-lg px-4 py-3 rounded-3 fw-semibold shadow-sm transition-transform"
                                onClick={() => handleAuth('user')}
                            >
                                Book an Appointment
                            </button>
                            <button
                                className="btn btn-outline-dark btn-lg px-4 py-3 rounded-3 fw-semibold transition-transform"
                                onClick={() => handleAuth('doctor')}
                            >
                                Doctor Login
                            </button>
                        </div>
                        <div className="mt-5 d-flex align-items-center gap-4 text-sm text-secondary">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-check-circle-fill text-success me-2"></i> Verified Doctors
                            </div>
                            <div className="d-flex align-items-center">
                                <i className="bi bi-check-circle-fill text-success me-2"></i> Instant Support
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Background Decor */}
            <div className="position-absolute top-0 end-0 h-100 w-50 d-none d-lg-block"
                style={{
                    background: `linear-gradient(90deg, #ffffff 0%, rgba(255,255,255,0) 100%), url('https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center right',
                    opacity: 0.9
                }}>
            </div>
        </section>
    );
};

export default HeroSection;
